<template>
    <div style="height: 100vh" v-loading="isLoading" element-loading-background="rgba(0, 0, 0, 0.1)">
        <!--表頭-->
        <div class="page_top">
            <div class="title">
                <i class="icon" id="icon" @click="back()"></i>
                <span class="header-text">貨櫃託運</span>
            </div>
        </div>
        <router-view></router-view>
        <!--內容-->
        <div class="container pt-3 pb-2  scrollable-container" v-infinite-scroll="fetchContainers"
             infinite-scroll-disabled="disabled"
             infinite-scroll-immediate = "false">
            <!-- 返回頂部 -->
            <el-backtop target=".scrollable-container" :right="30" :bottom="130"/>
            <!-- 搜尋 -->
            <div class="search-sort-container mb-3">
                <el-input
                    v-model="keyword"
                    placeholder="請輸入搜尋內容"
                    clearable
                    class="search-input"
                ></el-input>
                <!-- refresh 按鈕 -->
                <el-button type="info" plain class="search-button" @click="searchContainers" icon="el-icon-refresh" style="height: 40px"/>
            </div>

            <el-empty v-if="shipment_orders.length === 0 && isLoading == false" description="尚無託運資料"></el-empty>
            <el-card class="mt-3" v-for="item in shipment_orders" :key="item.id" shadow="always"
                     style="border-color: #909399">
                <div class="d-flex justify-content-between">
                    <div>
                        <div class="el-fs-small">
                            <i class="fas fa-calendar-alt me-2 text-secondary"></i>
                            <span class="fw-b">起運日 {{ item.start_date }}</span>
                        </div>
                        <div class="fw-bold my-3 el-fs-large lh-base">{{ item.title }}</div>
                        <div class=" el-fs-small ">
                            <el-tag class="me-1" effect="dark">{{ item.container_type.name }}</el-tag>
                            <el-tag v-if="item.is_dangerous" type="danger" class="me-1" effect="dark">
                                <i class="fas fa-exclamation-circle me-1 "></i>危險物品
                            </el-tag>
                        </div>
                    </div>
                    <el-tag
                        :type="getStatusTagType(item.status.id)"
                        effect="light"
                        class="align-self-start"
                    >
                        {{ item.status.name }}
                    </el-tag>
                </div>
                <hr/>

                <div class="mb-3"
                     v-for="location in item.locations.slice().sort((a, b) => (a.location_type - b.location_type))"
                     :key="location.id">
                    <div class="mb-1">
                        <i class="fas fa-map-marker-alt text-secondary me-2 mb-1 text-danger"></i>
                        <span class="fw-bold">
                        <template v-if="location.location_type === 1">從</template>
                        <template v-else-if="location.location_type === 2">到</template>
                        {{ location.name }}
                      </span>
                    </div>
                    <div class="el-fs-small ms-4 text-muted">{{ location.full_address }}</div>
                </div>

                <div class="mt-4">
                    <el-button v-if="[1,2,3].includes(item.status.id)" type="danger" plain class="  mx-1"
                               @click="cancelContainer(item.id)"
                    >取消
                    </el-button>
                    <el-button v-if="item.status.id === 1" type="warning" plain class="  mx-1"
                               @click="goToEdit(item.id)">
                        修改
                    </el-button>
                    <el-button type="info" plain class="float-end  mx-1 mb-3" @click="goToDetail(item.id)"
                    >詳細
                    </el-button>
                    <el-button v-if="[3,6].includes(item.status.id) && item.payment_code_generated == 0" type="warning" plain class="mx-1" @click="goToPay(item.id)">付款
                    </el-button>
                </div>
            </el-card>
        </div>

        <ContainerBottomNav/>


    </div>
</template>
<style scoped>
.scrollable-container {
    max-height: calc(100vh - 144px); /* 設置最大高度 */
    overflow-y: auto; /* 啟用垂直滾動條 */
}

.search-sort-container {
    display: flex;
    align-items: center;
    gap: 10px; /* 控制元素之間的間距 */
}

.search-input {
    flex: 1; /* 讓輸入框自動填滿剩餘空間 */
}


.el-backtop {
    opacity: 0.75;
}
</style>
<script>
import ContainerBottomNav from '@/components/ContainerBottomNav.vue';
import FN from "@/components/fn.vue";
import {GET_SHIPMENT_ORDER} from "@/api";

export default {
    mixins: [FN],
    components: {
        ContainerBottomNav
    },
    name: 'ContainerIndex',
    data() {
        return {
            keyword: "",
            shipment_orders: [],
            isLoading: false,
            page: 1,
            last_page: 1,
            isHistory: 0, // 是否為歷史資料
        };
    },
    computed: {
        disabled() {
            if (this.isError) {
                return true;
            }
            return this.isLoading;
        },
    },
    methods: {
        /** 返回上一頁 */
        back() {
            this.$router.push('/home');
        },
        /** 取得貨櫃資料 */
        fetchContainers() {
            this.isError = false;
            this.isLoading = true;
            if (this.page > this.last_page) {
                setTimeout(() => {
                    this.isLoading = false
                }, 2000)
                return;
            }

            this.FETCH({
                key: 'GET_SHIPMENT_ORDER',
                keyword: this.keyword,
                page: this.page,
                is_history: this.isHistory,
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        this.last_page = res.pagination.last_page;
                        this.shipment_orders = [...this.shipment_orders, ...res.pagination.data];
                        this.page++;
                        this.isLoading = false;
                    } else {
                        this.$message('網路異常，請稍後再試');
                        this.isError = true;
                        this.isLoading = false;
                    }
                }).catch(() => {
                this.isLoading = false;
            });
        },
        /** 進入編輯頁面 */
        goToEdit(id) {
            this.$router.push({name: 'ContainerEdit', params: {id}});
        },
        /** 進入詳細頁面 */
        goToDetail(id) {
            this.$router.push({name: 'ContainerDetail', params: {id}});
        },
        /** 刪除貨櫃 */
        cancelContainer(id) {
            this.$confirm('確定要刪除這筆資料嗎？', '刪除確認', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.FETCH({
                    key: 'CANCEL_SHIPMENT_ORDER',
                    id: id,
                })
                    .then((res) => {
                        if (+(res || {}).code === -3) {
                            this.checkNewToken(this.getChannel)
                        } else if (+(res || {}).code === 0) {
                            this.$notify({
                                title: '成功',
                                message: '託運單已取消。',
                                type: 'success',
                            });
                            this.isLoading = false;
                            this.searchContainers(); // 取消後重新載入列表
                        } else {
                            this.$message('網路異常，請稍後再試');
                            this.isError = true;
                            this.isLoading = false;
                        }
                    }).catch(() => {
                    this.isLoading = false;
                });
                // 使用者按下「確定」
                this.$message({
                    type: 'success',
                    message: '刪除成功'
                });
                // 在這裡執行實際刪除的邏輯
            }).catch(() => {
                return false;
            });
        },
        /** 搜尋貨櫃 */
        searchContainers() {
            this.page = 1;
            this.last_page = 1;
            this.shipment_orders = [];
            this.fetchContainers();
        },
        /**
         * 根據狀態 id 回傳對應 el-tag type
         */
        getStatusTagType(statusId) {
            switch (statusId) {
                case 1: // 已建立
                    return 'info';
                case 2: // 報價中
                    return 'primary';
                case 3: // 待付訂金
                    return 'warning';
                case 4: // 等待運送
                    return 'info';
                case 5: // 運送中
                    return 'success';
                case 6: // 待付尾款
                    return 'warning';
                case 7: // 完成
                    return 'success';
                case 8: // 取消
                    return 'danger';
                case 9: // 失效
                    return 'danger';
                default:
                    return 'default';
            }
        },
        /**
         * 前往付款頁面
         * @param id
         */
        goToPay(id) {
            this.$router.push({
                name: 'ContainerPayPage',
                params: {id: id},            // 傳 id
            });
        }

    },
    mounted() {
        // 檢查是否為歷史頁面
        if (this.$route.query.type === 'history') {
            this.isHistory = 1;
        } else {
            this.isHistory = 0;
        }
        // 初始化取得列表資料
        this.searchContainers();

    },
    watch: {
        '$route.query.type'(newType) {
            if (newType === 'history') {
                this.isHistory = 1;
                this.searchContainers();
            } else {
                this.isHistory = 0;
                this.searchContainers();
            }
        },
        keyword(newKeyword) {
            this.page = 1;
            this.last_page = 1;
            this.shipment_orders = [];
            this.searchContainers();
        }
    }
};


</script>
